import { Platform } from 'react-native'

/** Detect if running in a mobile browser */
export const getIsMobile = () => {
  if (Platform.OS !== 'web') {
    return true
  }

  return 'userAgentData' in navigator && navigator.userAgentData && typeof navigator.userAgentData === 'object'
    ? 'mobile' in navigator.userAgentData && !!navigator.userAgentData.mobile
    : // @ts-expect-error Mobile only property
      navigator.share &&
        (window.ontouchstart || navigator.maxTouchPoints > 0) &&
        matchMedia('only screen and (max-width: 767px)').matches
}
